/** ISO(YYYY-MM-DD) → Date */
export function isoToDate(iso) {
  if (!iso) return null;
  const [y, m, d] = String(iso).slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

/** Date → ISO(YYYY-MM-DD) */
export function dateToIso(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** 달력상 유효한 날짜인지 (미래 제한 없음) */
export function isValidCalendarDateParts(year, month, day) {
  const y = Number(year);
  const m = Number(month);
  const d = Number(day);
  if (!Number.isInteger(y) || !Number.isInteger(m) || !Number.isInteger(d)) return false;
  if (m < 1 || m > 12 || d < 1 || d > 31) return false;

  const date = new Date(y, m - 1, d);
  return date.getFullYear() === y && date.getMonth() === m - 1 && date.getDate() === d;
}

/** 저장값에서 ISO 날짜(YYYY-MM-DD) 추출 */
export function extractDateIso(raw) {
  if (raw == null || raw === '') return '';
  const s = String(raw).trim();
  const isoMatch = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch && isValidCalendarDateParts(isoMatch[1], isoMatch[2], isoMatch[3])) {
    return `${isoMatch[1]}-${isoMatch[2]}-${isoMatch[3]}`;
  }
  return parseDateDigits(s.replace(/\D/g, ''));
}

/** YYYYMMDD(8자리) → YYYY-MM-DD */
export function parseDateDigits(rawDigits) {
  const digits = String(rawDigits || '').replace(/\D/g, '');
  if (digits.length !== 8) return '';

  const year = digits.slice(0, 4);
  const month = digits.slice(4, 6);
  const day = digits.slice(6, 8);
  if (!isValidCalendarDateParts(year, month, day)) return '';
  return `${year}-${month}-${day}`;
}

/** ISO → 화면 표시 (1960-05-05 → 1960.05.05) */
export function formatDateIsoToDisplay(iso) {
  if (!iso) return '';
  const [y, m, d] = String(iso).slice(0, 10).split('-');
  if (!y || !m || !d) return '';
  return `${y}.${m}.${d}`;
}

/** 입력 중 숫자 → YYYY.MM.DD 표시 */
export function formatDateDigitsToDisplay(rawDigits) {
  const digits = String(rawDigits || '').replace(/\D/g, '').slice(0, 8);
  if (!digits) return '';
  if (digits.length <= 4) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 4)}.${digits.slice(4)}`;
  return `${digits.slice(0, 4)}.${digits.slice(4, 6)}.${digits.slice(6)}`;
}
